module.exports = __webpack_public_path__ + "static/img/gif_loader.d211127.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gif_loader.gif
// module id = 437
// module chunks = 1